import { FC, useEffect } from 'react';

import { getSelectedEmailTemplates, getSelectedNamedEmailTemplates } from '@features/emailTemplatesSlice';
import useTranslateEmailTemplates from '@hooks/useTranslateEmailTemplates';
import NewOrderBase from '@routes/NewOrder/NewOrderBase';
import { ROUTES } from '@routes/constants';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const NewOrderEmailTemplates: FC = () => {
  const selectedEmailTemplates = useSelector(getSelectedEmailTemplates);
  const namedSelected = useSelector(getSelectedNamedEmailTemplates);
  const { mutateAsync, isLoading, error, isError, reset } = useTranslateEmailTemplates();
  const navigate = useNavigate();

  useEffect(() => {
    if (!selectedEmailTemplates || !selectedEmailTemplates.length) navigate(ROUTES.EMAIL_TEMPLATES);
  }, [selectedEmailTemplates, navigate]);

  return (
    <NewOrderBase
      type={'email templates'}
      mutationError={error}
      mutationIsError={isError}
      mutationIsLoading={isLoading}
      mutationReset={reset}
      selected={selectedEmailTemplates}
      onSend={(data) => mutateAsync({ ...data, ids: selectedEmailTemplates })}
      namedSelected={namedSelected}
    />
  );
};

export default NewOrderEmailTemplates;
